import { Fragment } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useDistributionPoints } from "hooks/distributionPoints/useDistributionPoints";

interface DistributionPointInfoSectionProps extends RouteComponentProps {
  distributionPointId: string;
}

export function DistributionPointInfoSection({
  distributionPointId,
  history,
}: DistributionPointInfoSectionProps) {
  const { onSelectDistributionPointId } = useDistributionPoints();
  function handleClickOnEdit() {
    onSelectDistributionPointId(distributionPointId);
    history.push(`distributionPoints/${distributionPointId}`);
  }

  return (
    <Fragment>
      <div style={{ display: "flex" }}>
        <Tooltip title="Editar">
          <a
            onClick={() => {
              handleClickOnEdit();
            }}
          >
            <EditOutlined style={{ fontSize: "20px", margin: "3px" }} />
          </a>
        </Tooltip>
      </div>
    </Fragment>
  );
}

export default withRouter(DistributionPointInfoSection);
